import { ExportState, useRepositoryQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export const useExports = (
    start: string,
    end: string,
    states: Array<ExportState> | null,
    reportType: string | null | undefined,
    ownerProfileId: string | null | undefined
) => {
    const enterpriseId = useCurrentEnterpriseId();

    return useRepositoryQuery('exports', 'search', {
        enterpriseId,
        start,
        end,
        states,
        reportType,
        ownerProfileId,
    });
};
